module.exports = __webpack_public_path__ + "static/media/14.3388cf87.jpeg";